import { useParams } from "react-router-dom";

import { DashboardPowerBiByCode } from "../components/DashboardPowerBiByCode";

export function PowerBiPage() {
  const { code } = useParams();

  return <DashboardPowerBiByCode code={code ?? ""} />;
}
